import 'react-app-polyfill/ie11';
import 'core-js';
import config from './config';
import * as Sentry from '@sentry/browser';

import React from 'react';
import ReactDOM from 'react-dom';

import createStore from 'store/createStore';

// Styles
import 'styles/core.css';

// Components
import App from 'components/App';

if (config.SENTRY) {
  Sentry.init({
    dsn: config.SENTRY,
    environment: config.ENV,
  });
}

// ========================================================
// Render Setup
// ========================================================
const MOUNT_NODE = document.getElementById('root');

ReactDOM.render(<App store={createStore()} />, MOUNT_NODE);
